import { fetchWorkingHours } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";

export async function updateWorkingHoursPageState(isMasterKeyValid, languageKey, workingHoursFilters, setWorkingHoursFlters, setWorkingHoursData) {
  const isInitialLoad = workingHoursFilters.isInitialLoad;
  const requestBody = extractRequestBodyFromFilters(workingHoursFilters, isInitialLoad);
  let wagesData = await fetchWorkingHours(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  let { context, reportData } = wagesData.data;
  let labels = wagesData.labels;
  let submitedFilters = context.filters;
  let nextAvailableFilters = context.nextAvailableFilters;
  let updatedFilters = await updateFilters(workingHoursFilters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey);
  setWorkingHoursFlters(updatedFilters);
  let reversedReportData = reportData.reverse();
  setWorkingHoursData({ data: reversedReportData, labels: labels });
}
